// import PropTypes from 'prop-types'
import { useState } from 'react'

import Button from 'components/Button'

import { ApplyButton, Buttons, Main, OpenButton, Root } from './SmallScreenModal.style'

const SmallScreenModal = ({ children, toggleText }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <OpenButton>
        <Button text={toggleText} width="full" variant="outlined" onClick={() => setOpen(true)} />
      </OpenButton>
      <Root $open={open}>
        <Main>{children}</Main>
        <Buttons>
          <ApplyButton>
            <Button text="Apply" width="full" onClick={() => setOpen(false)} />
          </ApplyButton>
        </Buttons>
      </Root>
    </>
  )
}

SmallScreenModal.propTypes = {}

SmallScreenModal.defaultProps = {}

export default SmallScreenModal
